import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PenLine, ArrowLeft, Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { db } from "@/lib/db";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Simulação ou chamada real ao backend
      await db.requestPasswordReset(email);
      setSent(true);
      toast.success("E-mail enviado!");
    } catch (err) {
      toast.error("Erro: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-[#F6F5F0] flex items-center justify-center p-6">
        <div className="w-full max-w-md text-center">
          <CheckCircle2 className="w-16 h-16 text-[#D9381E] mx-auto mb-6" />
          <h1 className="font-serif text-4xl mb-4">Verifique seu e-mail</h1>
          <p className="text-[#4A4A4A] mb-8 leading-relaxed">
            Enviamos instruções para recuperar sua senha para <strong>{email}</strong>. 
            Não esqueça de verificar a pasta de spam.
          </p>
          <Link to="/login">
            <Button variant="outline" className="rounded-none w-full py-6">
              Voltar para o Login
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F6F5F0] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="flex items-center gap-2 text-sm text-[#8A8A8A] hover:text-black mb-10 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Voltar para o login
        </Link>
        
        <div className="flex items-center gap-2 mb-8">
          <PenLine className="w-5 h-5 text-[#D9381E]" strokeWidth={2.5} />
          <span className="font-serif text-2xl font-bold">RevisaPro</span>
        </div>

        <h1 className="font-serif text-4xl mb-2">Recuperar senha</h1>
        <p className="text-[#4A4A4A] mb-8">Insira seu e-mail para receber o link de recuperação.</p>

        <form onSubmit={onSubmit} className="space-y-6 bg-white border border-black/10 p-8 shadow-editorial">
          <div>
            <Label htmlFor="email" className="text-xs font-mono uppercase tracking-widest mb-2 block">E-mail cadastrado</Label>
            <Input 
              id="email" type="email" value={email} 
              onChange={(e) => setEmail(e.target.value)} required
              className="rounded-none border-black/20" 
              placeholder="exemplo@email.com"
            />
          </div>
          
          <Button type="submit" disabled={loading}
            className="w-full rounded-none bg-[#D9381E] hover:bg-[#B82914] text-white py-6 flex items-center justify-center gap-2">
            {loading ? "Enviando..." : <><Mail className="w-4 h-4" /> Enviar link de recuperação</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
